import * as React from 'react';
import { observer } from 'mobx-react';
import ParticipantsStore from '../../../../../../../ParticipantsStore';
import UserGroupMembershipsStore from '../Store';
import New from './New';
import Success from './Success';
import Error from './Error';
import ModalStore from '../../../../../../Modal/Store';
import Loader from '../../../../../../Loader';

interface Props {
  participantsStore: ParticipantsStore;
  userGroupMembershipsStore: UserGroupMembershipsStore;
  modalStore: ModalStore;
}

const FormState: React.FC<Props> = ({
  participantsStore,
  userGroupMembershipsStore,
  modalStore,
}) => {
  const { state } = userGroupMembershipsStore;
  switch (state.kind) {
    case 'waiting':
    case 'loading-for-new':
    case 'creating':
      return <Loader className="h-full py-40" />;
    case 'ready':
      return (
        <New
          participantsStore={participantsStore}
          userGroupMembershipsStore={userGroupMembershipsStore}
          state={state}
        />
      );
    case 'succeeded':
      return <Success state={state} modalStore={modalStore} />;
    case 'load-error':
    case 'new-form-submission-error':
    case 'error':
      return <Error />;
  }
};

export default observer(FormState);
